import { render, staticRenderFns } from "./TestReferenceModel.vue?vue&type=template&id=1ae4e5ff"
import script from "./TestReferenceModel.vue?vue&type=script&lang=js"
export * from "./TestReferenceModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports